import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NewPlanOption } from '../../models/new-plan-option';
import { SharedStateService } from '../../services/shared-state/shared-state.service';

@Component({
  selector: 'app-new-plan-option',
  templateUrl: './new-plan-option.component.' + environment.brand + '.html',
  styleUrls: ['./new-plan-option.component.' + environment.brand + '.css']
})
export class NewPlanOptionComponent {
  @Input() data: NewPlanOption;
  buttonText = '';

  constructor(private sharedStateService: SharedStateService) {
    if (!this.sharedStateService.justBrowsing) {
      this.buttonText = 'View Quote';
    } else {
      this.buttonText = 'Buy Now';
    }
  }

  viewQuote(): void {
    if (this.data && this.data.price > 0) {
      this.sharedStateService.newPlanOption = this.data;
      // decide where to direct the user
      if (!this.sharedStateService.justBrowsing) {
        this.sharedStateService.showViewQuote();
      } else {
        this.sharedStateService.showEnterCustomerDetails(false);
      }
    }
  }
}
